module.exports = __webpack_public_path__ + "e1c092e127943ec4289c847c5768b644.png";